module.exports = __webpack_public_path__ + "img/comp-30.aa096c10.png";